export const PurchaseReturnStatusEnum = Object.freeze({
  NONE: "NONE",
  PARTIALLY_RETURNED: "PARTIALLY_RETURNED",
  FULLY_RETURNED: "FULLY_RETURNED",
});
